<template>
  <card>
    <template #header>
      <card-header>
        {{ $t("homes.percentageOfProjectPhases") }}
        <template #action>
          <el-dropdown @command="techAreaOnSelected" v-show="techAreaList.length > 0">
            <span class="el-dropdown-link">
              {{ selectedTechArea.value }}
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item,index) in techAreaList"
                :key="index"
                :command="item"
              >{{ item.value }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </card-header>
    </template>
    <div class="chart">
      <chart id="chart2" ref="projectPhaseChart" @chartClick="click" :options="options" />
    </div>
  </card>
</template>

<script>
import { selectTechnicalArea, percentageOfProjectPhases } from "@/api/homes";

export default {
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      selectedTechArea: "",
      techAreaList: [],

      xAxis: [],
      Values: []
    };
  },
  computed: {
    lang() {
      return this.$store.state.app.language;
    },
    options() {
      return {
        color:['#EB7E65','#83D0EF','#A285D2','#FFAB67','#5B8FF9','#73DEB3','#7585A2','#F7C739','#92865D','#C6EBF8','#A5ADBE','#FBE5A2'],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: 10,
          top: 0,
          bottom: 0,
          icon: "circle",
          textStyle: {
            color: "#999999"
          },
          data: this.xAxis
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "60%"],
            avoidLabelOverlap: true,
            center: ["78%", "50%"],
            data: this.Values,
            label: {
              formatter: "{c}"
            }
          }
        ]
      };
    }
  },
  watch: {
    lang() {
      this.loadTechArea()
    }
  },
  created() {
    this.loadTechArea()
    this.loadChartData()
  },
  mounted() {},
  destroyed() {},
  methods: {
    loadTechArea() {
      selectTechnicalArea().then(resp => {
        this.techAreaList = resp.data;

        if (this.techAreaList.length > 0) {
          this.selectedTechArea = this.techAreaList[0];

          this.loadChartData();
        }
      });
    },

    /** 切换技术领域 */
    techAreaOnSelected(command) {
      this.selectedTechArea = command;

      this.loadChartData();
    },

    /** 加载图标数据 */
    loadChartData() {
      percentageOfProjectPhases(this.selectedTechArea.key).then(resp => {
        const data = resp.data;

        this.xAxis = data.names;
        this.Values = data.values;

        this.$refs.projectPhaseChart.setOption(this.options);
      });
    },

    click(params) {
      this.$router.push({
        path: "/projectManagement/projectListView",
        query: {
          technicalArea: this.selectedTechArea.key,
          developmentCode: params.data.code
        }
      });
    }
  }
};
</script>
<style  scoped>
.chart {
  height: 170px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  color: rgb(153, 153, 153);
  font-size: 14px;
}
</style>
